import React from 'react';
// prop-types is a library for typechecking of props
import PropTypes from 'prop-types';

// Soft UI Dashboard PRO React components
import SuiBox from 'components/SuiBox';

import SuiTypography from 'components/SuiTypography';
// Soft UI Dashboard PRO React base styles
import typography from 'shared/theme/base/typography';

// Custom styles for the Footer
import styles from 'examples/Footer/styles';

import { Box, Link } from '@mui/material';

function Footer({ company, links }) {
  const { href, name } = company;
  const { size } = typography;
  const classes = styles();

  const renderLinks = () =>
    links.map((link) => (
      <SuiBox key={link.name} component="li" px={2}>
        <Link href={link.href} target="_blank">
          <SuiTypography variant="button" fontWeight="regular" textColor="text">
            {link.name}
          </SuiTypography>
        </Link>
      </SuiBox>
    ));

  return (
    <SuiBox
      width="100%"
      display="flex"
      flexDirection={{
        xs: 'column',
        lg: 'row',
      }}
      sx={{ position: 'absolute', bottom: 0, left: 0, right: 0 }}
      justifyContent="space-between"
      alignItems="center"
      px={1.5}
      py={1}
    >
      <SuiBox
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexWrap="wrap"
        color="text"
        fontSize={size.sm}
      >
        &copy;
        <Link href={href} target="_blank">
          <SuiTypography variant="button" fontWeight="medium">
            &nbsp;{name}&nbsp;
          </SuiTypography>
        </Link>
        <Box component="span" sx={{ display: { xs: 'none', md: 'inline' } }}>
          -
        </Box>
        <Box
          component="p"
          sx={{ display: { xs: 'block', md: 'inline', textAlign: 'center' } }}
        >
          &nbsp;Đặt là đi, dùng mê li!&nbsp;
        </Box>
      </SuiBox>
      <SuiBox component="ul" customClass={classes.footer_list}>
        {renderLinks()}
      </SuiBox>
    </SuiBox>
  );
}

// Setting default values for the props of Footer
Footer.defaultProps = {
  company: { href: 'https://www.mylahomestay.com/', name: 'Bookdee' },
  links: [
    // { href: 'https://www.facebook.com/homestayvungtauu/', name: 'Hỗ trợ' },
  ],
};

// Typechecking props for the Footer
Footer.propTypes = {
  company: PropTypes.objectOf(PropTypes.string),
  links: PropTypes.arrayOf(PropTypes.object),
};

export default Footer;
